import { sectionAPI } from '../services/sectionAPI'
import { $all, $one } from '../utils/querySelector'
import { stringToHTML } from '../utils/toHTML'
import { Cart } from '../utils/cart';

export const filter = () => {
  $all('.filter-input').forEach(
    input => {
      input.addEventListener(
        'change',
        changeFilter
      )
    }
  )
}

async function changeFilter(e) {
  e.preventDefault();

  if (!url_filter) return null;
  
  if(url_filter.includes('collections')){

  const url =  url_filter+ '/' + e.target.value;

  window.history.replaceState({}, null, url);

    const newFilter = await sectionAPI(url, 'products-collection');
    const listOfProducts = $one('#list-products', stringToHTML(newFilter));
  
    $one('.shopify-section.products-collection').innerHTML = listOfProducts.outerHTML;

   const cartInstance = new Cart();

   cartInstance.bindClicks();

  }

}

